import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Image,
  Button,
  Link,
  Flex,
  Heading,
  Text,
} from '@chakra-ui/react';
import React, { useRef, useEffect, useState } from 'react';
import SKButton from '../SKButton';
import ProcessingImg from 'assets/icons/payment_processing.gif';
import ProcessedImg from 'assets/icons/payment_successful.gif';
import StillProcessingSVG from 'assets/icons/payment_still_processing.png';
import FailedImg from 'assets/icons/payment_failed.gif';
import { Box } from '@chakra-ui/layout';
import { StorageService } from 'service/Storage';
const TRANSACTION_STATES = {
  PROCESSING: {
    title: 'Payment Processing',
    gif: ProcessingImg,
    color: '#D1A659',
    info: 'The payment is generally credited to your account within 6 hours. Until then, your Chillars are safe with us.',
  },
  PROCESSED: {
    title: 'Payment Successful',
    gif: ProcessedImg,
    color: '#52B358',
  },
  FAILED: {
    title: 'Payment Failed',
    gif: FailedImg,
    color: '#DD5555',
  },
  STILL_PROCESSING: {
    title: 'Payment is still processing',
    gif: StillProcessingSVG,
    color: '#D1A659',
    info: 'Payment request has been sent to your bank account. Chillars will be refunded back to the wallet incase of failure.',
  },
};
export const PROCESSING = 'PROCESSING';
export const PROCESSED = 'PROCESSED';
export const FAILED = 'FAILED';
export const STILL_PROCESSING = 'STILL_PROCESSING';
export const PAYTM = 'PAYTM';
export const UPI = 'UPI';
export const AMAZON_PAY = 'AMAZON_PAY';
export default function SuccessModal({
  id,
  isOpen,
  onClose,
  amount,
  transaction,
  pollingStatus,
  intervalId,
}) {
  let state = pollingStatus
    ? transaction?.paymentStatus || PROCESSING
    : STILL_PROCESSING;
  const [stateInfo, setStateInfo] = useState(PROCESSING);

  useEffect(() => {
    setStateInfo(PROCESSING);
  }, []);
  useEffect(() => {
    if (!isOpen) return;
    if (stateInfo === PROCESSED || stateInfo === FAILED) {
      return;
    }
    if (
      (pollingStatus && transaction?.paymentStatus === PROCESSED) ||
      (pollingStatus && transaction?.paymentStatus === FAILED)
    )
      clearInterval(intervalId);
    setStateInfo(state);
  }, [state]);
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        size="sm"
        trapFocus={false}
      >
        <ModalOverlay />
        <ModalContent align="center" bg="#FFE7D5" borderRadius={12} width="90%">
          {(!pollingStatus ||
            stateInfo === PROCESSED ||
            stateInfo === FAILED) && <ModalCloseButton />}
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Box></Box>
            <ModalHeader
              color={TRANSACTION_STATES[stateInfo].color}
              align="center"
              justifyContent="center"
              mt={6}
            >
              <Flex direction="column" alignItems="center">
                {stateInfo === PROCESSING && (
                  <Image
                    src={TRANSACTION_STATES[PROCESSING].gif}
                    margin="auto"
                    alt="payment processing"
                    width="auto"
                    height="150px"
                  />
                )}
                {stateInfo === 'FAILED' && (
                  <Image
                    src={TRANSACTION_STATES[FAILED].gif}
                    margin="auto"
                    alt="payment failed"
                    width="auto"
                    height="150px"
                  />
                )}
                {stateInfo === PROCESSED && (
                  <Image
                    src={TRANSACTION_STATES[PROCESSED].gif}
                    margin="auto"
                    alt="payment successful"
                    width="auto"
                    height="150px"
                  />
                )}
                {stateInfo === STILL_PROCESSING && (
                  <Image
                    src={TRANSACTION_STATES[STILL_PROCESSING].gif}
                    margin="auto"
                    alt="payment still processing"
                    width="auto"
                    height="150px"
                  />
                )}
                <Heading
                  as="h4"
                  size="md"
                  fontSize="24px"
                  color={TRANSACTION_STATES[stateInfo].color}
                >
                  {TRANSACTION_STATES[stateInfo].title}
                </Heading>
                <Text fontSize="36px" color="#111111">
                  ₹ {amount / 10}
                </Text>
              </Flex>
            </ModalHeader>
            <Box>
              {stateInfo === PROCESSED && (
                <>
                  {' '}
                  <ModalBody fontSize="16px" textAlign="center" color="#BE6F4F">
                    {transaction.paymentMethod === AMAZON_PAY && (
                      <>Amazon Pay - {transaction.paymentAddress}</>
                    )}
                    {transaction.paymentMethod === PAYTM && (
                      <>Paytm - {transaction.paymentAddress}</>
                    )}
                    {transaction.paymentMethod === UPI && (
                      <>UPI - {transaction.paymentAddress}</>
                    )}
                  </ModalBody>
                  <ModalFooter
                    justifyContent="center"
                    align="center"
                    margin="auto"
                  ></ModalFooter>
                </>
              )}
              {(stateInfo === STILL_PROCESSING || stateInfo === PROCESSING) && (
                <>
                  <ModalBody fontSize="14px" textAlign="center" color="#BE6F4F">
                    <Text color="#2F2F2F" fontWeight="semibold">
                      Note:
                    </Text>
                    {TRANSACTION_STATES[stateInfo].info}
                  </ModalBody>
                  <ModalFooter
                    justifyContent="center"
                    align="center"
                    margin="auto"
                  ></ModalFooter>
                </>
              )}
              {stateInfo === FAILED && (
                <>
                  <ModalBody fontSize="14px" textAlign="center">
                    {TRANSACTION_STATES[stateInfo].info}
                  </ModalBody>
                  {transaction?.errorReason && (
                    <ModalFooter
                      justifyContent="center"
                      align="flex-start"
                      margin="auto"
                      style={{ gap: '0.2rem' }}
                      color="#BE6F4F"
                    >
                      <span
                        style={{ color: '#2F2F2F', fontWeight: 'semibold' }}
                      >
                        Reason:{' '}
                      </span>{' '}
                      {transaction?.errorReason}
                    </ModalFooter>
                  )}
                </>
              )}
            </Box>
          </Box>
        </ModalContent>
      </Modal>
    </>
  );
}
